import { useEffect } from 'react';
import { useUserStore } from '../store/userStore';
import { configurePurchases, identifyPurchaser, resetPurchaser } from '../services/purchases';

/**
 * Initialise RevenueCat au démarrage (iOS, idempotent) et lie les achats au compte Supabase :
 * logIn(user.id) une fois connecté, logOut à la déconnexion. Tout est best-effort (no-op hors iOS).
 */
export function useRevenueCat() {
  const userId = useUserStore((s) => s.user?.id ?? null);

  useEffect(() => {
    configurePurchases();
  }, []);

  useEffect(() => {
    if (userId) void identifyPurchaser(userId);
    else void resetPurchaser();
  }, [userId]);
}
